// extracted by mini-css-extract-plugin
export var copyIcon = "_za-2";
export var discountCard = "_za-0";
export var discountCode = "_za-3";
export var discountContent = "_za-1";
export var loadingCard = "_za-4";